import { useAtomValue } from 'jotai';

import { opalUserAtom } from '../atoms/opalUserAtom';
import { User } from '../types/user';

export const useOpalUser = (): {
  opalUser: User;
} => {
  const opalUser = useAtomValue(opalUserAtom);

  return { opalUser };
};
